
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index2Shru0M7u94vMCxI3VIBBvlcsUOysnOk2Oyd3I0TcUwMeta } from "/cre-app/client/pages/tag/index.ts?macro=true";
import { default as indexAwME1tAiJAxZHYht03IfRAVdC3A_g7yFVMT_45r7E47MYMeta } from "/cre-app/client/pages/news/index.ts?macro=true";
import { default as indexHv94_LvGso4o7PW3eML7WpJFsbQ7N6rC2mDUHIok6lUMeta } from "/cre-app/client/pages/events/index.ts?macro=true";
import { default as indexr6htLol_qFdpsnr8i22z96awrYDaRKrAu8I10j79X_45UMeta } from "/cre-app/client/pages/search/index.ts?macro=true";
import { default as indexdTgihNn0e3BYSSOtK1pyYq98q_4GumUA4VP3R2poKLIMeta } from "/cre-app/client/pages/tag-ai/index.ts?macro=true";
import { default as index7R52rfD0h_451dLCKHLjQ7D0I4bArGlf_1Zxby_45VVhKvMMeta } from "/cre-app/client/pages/tag/ui/index.ts?macro=true";
import { default as indexmjmwOHJdv6P4k_45KQn4UsdjzgWd4D5wXFVQ2EywUj9z8Meta } from "/cre-app/client/pages/article/index.ts?macro=true";
import { default as indexHzxzleS5hNHCup5yrbloD0c1b5kw6vjto0AD1HIASDgMeta } from "/cre-app/client/pages/journal/index.ts?macro=true";
import { default as indexsCsddymow_45BAP_45n5KGCQ7G2_EjIn6LqlFIZ0oDhLwlAMeta } from "/cre-app/client/pages/news/ui/index.ts?macro=true";
import { default as NewsAPIg9DlbCe1J_457CECGzI_hZd70mvzGuibLy_nWk_C0wMeta } from "/cre-app/client/pages/news/ui/News.vue?macro=true";
import { default as indexePvShEjjMqUF47SS_59jbC2aIr0zn5pw9MVX5FhCE_QMeta } from "/cre-app/client/pages/contacts/index.ts?macro=true";
import { default as seoeLFabm1UUnRoNNlPUPcDevL39Ysn_45Ellc0zpcEcASjsMeta } from "/cre-app/client/pages/events/lib/seo.ts?macro=true";
import { default as constyfF3jm_0Mab3MN2mEQxPFTucsKSL_45OcaKdZn8fktlX8Meta } from "/cre-app/client/pages/news/lib/const.ts?macro=true";
import { default as seog8eR4c4lVafpKliw0ZsNqGLqUcLlZrNmTgc6PphvivUMeta } from "/cre-app/client/pages/article/lib/seo.ts?macro=true";
import { default as indexBiHEIA_FYL_45wMrlSqoEiSOJAXTlni40ptWYXfXhbLHcMeta } from "/cre-app/client/pages/events/ui/index.ts?macro=true";
import { default as indexF6F8KQDFwRMQtQq8abXOvC6w3CVBXk0wmzvWUoLljbQMeta } from "/cre-app/client/pages/home-page/index.ts?macro=true";
import { default as seooLe09VK1kDVKlv_76jmrRRyR8Ht51pUeotPj4HPvsmwMeta } from "/cre-app/client/pages/journal/lib/seo.ts?macro=true";
import { default as indexCKczPCjawUmHp_45GtTXuV5wNLNAQtwTItOtR1TmSapAkMeta } from "/cre-app/client/pages/search/ui/index.ts?macro=true";
import { default as indexZhoHrDmvunks9W7gH8mnh4uZyD4UxJYIK688CF_eOuMMeta } from "/cre-app/client/pages/tag-ai/ui/index.ts?macro=true";
import { default as TagPageWVFxGsm2k4_N20defWaBhlBD4rNpLYFChUuVENJQ8LUMeta } from "/cre-app/client/pages/tag/ui/TagPage.vue?macro=true";
import { default as indexVDogcBBa47GlSNNQ_1b8fKMZ_457_NlP2UGHw9_45zhJXPkMeta } from "/cre-app/client/pages/article/ui/index.ts?macro=true";
import { default as constfwUQmeO1ZNEsUfME_45vvXKHKHcj9q_zLMk_MM3tqAWOIMeta } from "/cre-app/client/pages/events/lib/const.ts?macro=true";
import { default as indexyttRNxAUPqcAxu7V0xoqqC2J3y0XVFJUzqAFwXxnmOcMeta } from "/cre-app/client/pages/journal/ui/index.ts?macro=true";
import { default as const8YJQa_45VZHhSe3B4X5nWIOh4stYMsHiOFA4Mp9D0FwMQMeta } from "/cre-app/client/pages/tag-ai/lib/const.ts?macro=true";
import { default as index0LS_XXmmHmOJiuSlnn85vVObjck_45LFnPVVoFoUya63gMeta } from "/cre-app/client/pages/advertising/index.ts?macro=true";
import { default as indexntXBJNzIBxWHVEvNJy_45vLXD_ytmU4dm_Jv_csu97SDMMeta } from "/cre-app/client/pages/broker-pass/index.ts?macro=true";
import { default as indexD5rJcwyt4kmfuFCI43dwFmd9gv5_Iot7CoMUC68nn4YMeta } from "/cre-app/client/pages/contacts/ui/index.ts?macro=true";
import { default as seo2D9Ppas4e6dsVzivAohYN4R2pbKXz0R4gK1VgJ1ztLQMeta } from "/cre-app/client/pages/home-page/lib/seo.ts?macro=true";
import { default as SearchCTkBnCwYJyhXcnM_a8A0jlBRhqcD0dmd6_45AzG0wquz4Meta } from "/cre-app/client/pages/search/ui/Search.vue?macro=true";
import { default as indexNmF7fSbl6ALPsp0lJLXLjCfKwZTVjiwlFNhBMroWOWIMeta } from "/cre-app/client/pages/event-detail/index.ts?macro=true";
import { default as indexRAkm85457WuKSR7vPY2OzjrYO0XcSiDQAHob4uYM_45dwMeta } from "/cre-app/client/pages/home-page/ui/index.ts?macro=true";
import { default as constbw5CqpnhuYZsBoRkB5SSTJvG3tnQ1MHUqFgwpuUQqXEMeta } from "/cre-app/client/pages/home-page/lib/const.ts?macro=true";
import { default as indexOaWqu9Ycsc_45wwy5gnfztm2h3LzHGfkZzQdjI_45rDhlEUMeta } from "/cre-app/client/pages/advertising/ui/index.ts?macro=true";
import { default as indexMGIcyewMEy1CtOMXlDlIs_c_45xOfwHZ0iOGfNsUpbn7UMeta } from "/cre-app/client/pages/broker-pass/ui/index.ts?macro=true";
import { default as seoyNUEYwl_2kbqvPHbQYBY1caQB4tU7atRt4JOtyG6POMMeta } from "/cre-app/client/pages/event-detail/lib/seo.ts?macro=true";
import { default as indexbvC6peIQF4SknYTgL0t5gDNKiP5Ra16KUw9WoGEXZEIMeta } from "/cre-app/client/pages/gallery-detail/index.ts?macro=true";
import { default as indexriet1Bx3dCdLEzzZV3sDBvY3ImUxXCL76Y4XsULM8fYMeta } from "/cre-app/client/pages/speaker-detail/index.ts?macro=true";
import { default as TagAiPagexo2XU_456kd7yu4awG8AHIBAP6lcJfH1ICzcKsW4fWex0Meta } from "/cre-app/client/pages/tag-ai/ui/TagAiPage.vue?macro=true";
import { default as index2eJfwJGIxWpoCD8P_457Y05JQyx4B7zoaquGpVQOxtT9kMeta } from "/cre-app/client/pages/event-detail/ui/index.ts?macro=true";
import { default as EventsPageP_45hwvaD3d38b4trYrXGBqwZJNgkYSpjMLsjHGYHpQEMMeta } from "/cre-app/client/pages/events/ui/EventsPage.vue?macro=true";
import { default as indexOgZCPktqt68pnL0Tca6O32OHzOrYgF06rnpGov5O0FQMeta } from "/cre-app/client/pages/advertising_main/index.ts?macro=true";
import { default as seotgnLR3bHPit19sDDL9UtquvF4wlLyIVybqFDSsBO0u0Meta } from "/cre-app/client/pages/gallery-detail/lib/seo.ts?macro=true";
import { default as HomePagePnGz_45hbXFCVKevIwXI2GTJnv3yRxo1i5WMZWwCKRRD8Meta } from "/cre-app/client/pages/home-page/ui/HomePage.vue?macro=true";
import { default as seozmONwbk7nC1YX7JEKlg1Yj5d4VnrR7nhVRvVFi7gdw0Meta } from "/cre-app/client/pages/speaker-detail/lib/seo.ts?macro=true";
import { default as ArticlePageBy1BYpm3XkBrkuQF7vheRSpgS_45IFD94nSnIQxUpHyDMMeta } from "/cre-app/client/pages/article/ui/ArticlePage.vue?macro=true";
import { default as EventsTabBarVvKapgJe9kC38Rw2WQ5P29Vvb7PLvULteJ6L6FQl3wQMeta } from "/cre-app/client/pages/events/ui/EventsTabBar.vue?macro=true";
import { default as EventsTopBarXBRpNtfJKvza_uJBKaGOMCpi8eiOEBEY_cO4Osg2mhIMeta } from "/cre-app/client/pages/events/ui/EventsTopBar.vue?macro=true";
import { default as index3WURIDHEJY6y8HubHBaMoBMDSEKhNGOIiDjZDKosnscMeta } from "/cre-app/client/pages/gallery-detail/ui/index.ts?macro=true";
import { default as coverAccenthKoQQp0cPVj2METFDJMDjvavTNnxGz2bgXDZ_45zuekdoMeta } from "/cre-app/client/pages/journal/lib/coverAccent.ts?macro=true";
import { default as JournalHeros8wm8VhGC_45ytxHDoWa82OZk51kAnw5IO88hKojvz36QMeta } from "/cre-app/client/pages/journal/ui/JournalHero.vue?macro=true";
import { default as JournalPageipFbRxCDcGNbmLGvLE696BCTtGF2opDuuUSqd7m0oR8Meta } from "/cre-app/client/pages/journal/ui/JournalPage.vue?macro=true";
import { default as JournalTabsfKM3HkvRM3uQJK6FGpCn3wVBlZL3EgPzTIFqViWCeaAMeta } from "/cre-app/client/pages/journal/ui/JournalTabs.vue?macro=true";
import { default as index6EXtrEG7MlUBjtsu0CA0bAf4C5bbtX24q3uAI2eCLyUMeta } from "/cre-app/client/pages/speaker-detail/ui/index.ts?macro=true";
import { default as EventsSubTabsNJlXmSBjvuldqxM6PkkR6vYhxHoq3cAcEBAKYD80_4QMeta } from "/cre-app/client/pages/events/ui/EventsSubTabs.vue?macro=true";
import { default as getIssueMetapHJYuzoVevTeJ12NetcYQU8AeVZO0xfSi8acmKLrrisMeta } from "/cre-app/client/pages/journal/lib/getIssueMeta.ts?macro=true";
import { default as JournalChipsDuoxji2hsbpwciPzyV31RVu3_Zje84xwhFAvK9qEnPcMeta } from "/cre-app/client/pages/journal/ui/JournalChips.vue?macro=true";
import { default as JournalCoverQbdwR_jNJeQqaTZUBWuutbdGGpt1RKfDxLzN2y_45FL7MMeta } from "/cre-app/client/pages/journal/ui/JournalCover.vue?macro=true";
import { default as index5wpCiQr_45GXabS6FihvrKzOvG064qGYsBpxBJjR4Uta4Meta } from "/cre-app/client/pages/advertising_main/ui/index.ts?macro=true";
import { default as ContactsBodywvlHnhhOgIv3YLGdUYfR5AblnLoohbZm4oU2f_45Ea0ZYMeta } from "/cre-app/client/pages/contacts/ui/ContactsBody.vue?macro=true";
import { default as ContactsPagepL_6lcTymGJxrX5DNlAJm1_6YrK_455DEU8ZNi0w0Wp_454Meta } from "/cre-app/client/pages/contacts/ui/ContactsPage.vue?macro=true";
import { default as journal_46constiprkNCQPrKg1VUoalBX2ILVNlvRRgyS_45FAYUSus47IQMeta } from "/cre-app/client/pages/journal/lib/journal.const.ts?macro=true";
import { default as BrokerPage_45sdivS0i_LGaXVeTUoU7S2Y_MfmqTeR_84_45gOL_45KmR0Meta } from "/cre-app/client/pages/broker-pass/ui/BrokerPage.vue?macro=true";
import { default as useJournalData0jovgUeTzB8D310B4ByTvwJuevx_f3ufZHA1q_Ww_2oMeta } from "/cre-app/client/pages/journal/lib/useJournalData.ts?macro=true";
import { default as useJournalPageMo1MTqNab_45V411YPsp18dwZQCz69nLIvESDw7MMPJGkMeta } from "/cre-app/client/pages/journal/lib/useJournalPage.ts?macro=true";
import { default as JournalArchiveKYBPl4y4Z7ewefZaPIcMDd_m6U8uSsNCE3xznsIUvSEMeta } from "/cre-app/client/pages/journal/ui/JournalArchive.vue?macro=true";
import { default as AdvertisingVEJW2rgtnB2SbTcKVbWmdZhShRn_FwIzWTy80ArAxXsMeta } from "/cre-app/client/pages/advertising/ui/Advertising.vue?macro=true";
import { default as formatTimeAZTFaT8PPXPB6ZeapA3wxqwlsc80LROiOWcYx3BTtVgMeta } from "/cre-app/client/pages/event-detail/lib/formatTime.ts?macro=true";
import { default as useEventsFiltersL74DRetD33QWB7MtO9Sa4MwIQ_45Wfprf0NdJ2RT5fdoIMeta } from "/cre-app/client/pages/events/lib/useEventsFilters.ts?macro=true";
import { default as EventsRouterView_8wEyU0DqZAXtE1OeQOdlN_45Hxl7wpEbijco17ti_45v10Meta } from "/cre-app/client/pages/events/ui/EventsRouterView.vue?macro=true";
import { default as useJournalOrder0RHZ_457t_DlxBh_45k1Mg8WXYCLgIdhK0jGb0ZobopzNFwMeta } from "/cre-app/client/pages/journal/lib/useJournalOrder.ts?macro=true";
import { default as JournalYearPagebnls9JSr7BdFJqGVoXcNZfUUUndIm_45Byk8xQuUb_OfgMeta } from "/cre-app/client/pages/journal/ui/JournalYearPage.vue?macro=true";
import { default as loadSmartCaptchaJ742ZGXXiVAszHlSAolqoqI0vFqYL_j_eA7XqAV3p7sMeta } from "/cre-app/client/pages/journal/lib/loadSmartCaptcha.ts?macro=true";
import { default as JournalCardsGridzi1ofLiX7Q8VImSogjDrXK9S1Q_45tENkgzxAkB7hSZ9EMeta } from "/cre-app/client/pages/journal/ui/JournalCardsGrid.vue?macro=true";
import { default as JournalIssueCardikXJY9Q63fyX7xZb5KMp6_455KkOg1XFK0_459evb0xXzkEMeta } from "/cre-app/client/pages/journal/ui/JournalIssueCard.vue?macro=true";
import { default as JournalIssuePageDyrdMp3kwgiGQDkBDzezpUFCUA6X101KPHotA9VthTgMeta } from "/cre-app/client/pages/journal/ui/JournalIssuePage.vue?macro=true";
import { default as JournalOrderFormGODSgWIbjHTGFcaO46VABL4hrmeAC1LVooreidBRLaQMeta } from "/cre-app/client/pages/journal/ui/JournalOrderForm.vue?macro=true";
import { default as TagAiMaterialCardM3XhVPmVbah7XqfT7QP6TU5BCHKhwaVv8Y2SC3E5oZ4Meta } from "/cre-app/client/pages/tag-ai/ui/TagAiMaterialCard.vue?macro=true";
import { default as JournalOrderField1hxLPuXnE6Fh2IbRBW_45Oevz_45GBf5_45n9LLBzU9bF_45TnsMeta } from "/cre-app/client/pages/journal/ui/JournalOrderField.vue?macro=true";
import { default as JournalOrderModalE1g5vBRL85Kw8eSFOAaJGhkN_2_PTah4e9bW63dBq38Meta } from "/cre-app/client/pages/journal/ui/JournalOrderModal.vue?macro=true";
import { default as JournalRouterViewqNJySYwZ__Do5mzLQvFtX5KeRt0rLueehjdZ4CI0nN8Meta } from "/cre-app/client/pages/journal/ui/JournalRouterView.vue?macro=true";
import { default as EventsAfisha01yWbKiHq3C4Ch43Fv3efzic2Rhazw3iq6ULuffEYMUMeta } from "/cre-app/client/pages/events/ui/afisha/EventsAfisha.vue?macro=true";
import { default as EventsBannerK1smQ5JkX_458udFi_45YoWLdb9Oe7z2GPYP80oyM5qM9ewMeta } from "/cre-app/client/pages/events/ui/afisha/EventsBanner.vue?macro=true";
import { default as journalOrder_46const1OwRlnhngzE4B7FZ80k783rWSc6MAfm7vcr7zqZHuuYMeta } from "/cre-app/client/pages/journal/lib/journalOrder.const.ts?macro=true";
import { default as JournalIssuesPagedeZM197WqK85sJOTDSTEih3YVpvNRxqJwZXxPFL6zbGkMeta } from "/cre-app/client/pages/journal/ui/JournalIssuesPaged.vue?macro=true";
import { default as JournalRecommendedy4oHiUHLFuRAHt_D63cB5b7HovLDxeNKbFlXdwCh03gMeta } from "/cre-app/client/pages/journal/ui/JournalRecommended.vue?macro=true";
import { default as useEventDetailGyYTIoaj5Y9PrlPuz62yIRhxu9NbpY9x14icPzpRXyYMeta } from "/cre-app/client/pages/event-detail/lib/useEventDetail.ts?macro=true";
import { default as useJournalOrderFormX5mnXD6e2t0zsVvuY4SmeTy4Fm0I_6Yqfje5YMVbaPQMeta } from "/cre-app/client/pages/journal/lib/useJournalOrderForm.ts?macro=true";
import { default as JournalIssueButtonsJFBIZ7_45FFF8_frQBHwS7uvLuFHXwuAmHnvfBO20IIfMMeta } from "/cre-app/client/pages/journal/ui/JournalIssueButtons.vue?macro=true";
import { default as JournalOrderCaptchaeVFXUrb4kAnkcbsDAkxETlu5_45u22wCt8uS3V6a4nvwkMeta } from "/cre-app/client/pages/journal/ui/JournalOrderCaptcha.vue?macro=true";
import { default as JournalOrderSuccessYf_45QHF0dGbX2J8mH7AW0s8ZpU5RA_WWGttJIDm5xMycMeta } from "/cre-app/client/pages/journal/ui/JournalOrderSuccess.vue?macro=true";
import { default as JournalOrderSummaryb1Vug2XG9IaeKMqpYq46x3Sa3NN3N1OIFbRbPA27YFcMeta } from "/cre-app/client/pages/journal/ui/JournalOrderSummary.vue?macro=true";
import { default as JournalSectionRoutey7wD9qjRGNPCFeEWH647EBydp7X7nBTt2hqBvmXA51AMeta } from "/cre-app/client/pages/journal/ui/JournalSectionRoute.vue?macro=true";
import { default as ArticleNewObjectPage3HulB2CeJzeRtKL09PoS4HIfBJ2mlBtXdXjffl73FlsMeta } from "/cre-app/client/pages/article/ui/ArticleNewObjectPage.vue?macro=true";
import { default as formatHallCountHb17kxAmVPyrzr4C71G1MrM6JwekH_45Eywq_45_45IC1MaeYMeta } from "/cre-app/client/pages/event-detail/lib/formatHallCount.ts?macro=true";
import { default as EventDetailHeroGVRCowLtaCSC0ASKEfF1I7LKrogo7ZFf_45pR7eDZOX2IMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailHero.vue?macro=true";
import { default as EventDetailInfo8OUnRZbnWZf5LFf2nVreRyUV3Gd4zkZ2sWoUKELSB6sMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailInfo.vue?macro=true";
import { default as EventDetailPageKjtWDzoCSohDIrmzRK36h6MyXoVBC59nT9Fci3fNTT8Meta } from "/cre-app/client/pages/event-detail/ui/EventDetailPage.vue?macro=true";
import { default as JournalEditionFilterA9C3n28GjRuAPxPZaqzKbhXjLCmnTDFhsoTlYEyAL0cMeta } from "/cre-app/client/pages/journal/ui/JournalEditionFilter.vue?macro=true";
import { default as MaterialCardTextc3MUNyNA8JQt30BxE9gd4gBBGnKh3oFc34JES3S7764Meta } from "/cre-app/client/pages/event-detail/ui/MaterialCardText.vue?macro=true";
import { default as EventDetailFooterf7RYuKd1ir54LxOxdK915ZRiHYiar5yxCppxsAEUrl0Meta } from "/cre-app/client/pages/event-detail/ui/EventDetailFooter.vue?macro=true";
import { default as EventDetailHeaderyXkPtxcgMMhaRVEhUjA9hNpSC0EbIbUCH0_5v_3GFa4Meta } from "/cre-app/client/pages/event-detail/ui/EventDetailHeader.vue?macro=true";
import { default as MaterialCardImage2biBrpSntmuExXw11Cf0xve0rYlO1k0rLvo8tQsrVbgMeta } from "/cre-app/client/pages/event-detail/ui/MaterialCardImage.vue?macro=true";
import { default as EventsScheduleekJV8l9jB2ozcEZlEbnoXD5xr_4504_G_45GgsBt0I3QgdkMeta } from "/cre-app/client/pages/events/ui/schedule/EventsSchedule.vue?macro=true";
import { default as useGalleryModal6gzIFAga7QtSlrdFr9xmL5IBKggbUlBv1C7Wy_erhxQMeta } from "/cre-app/client/pages/gallery-detail/lib/useGalleryModal.ts?macro=true";
import { default as manualRegistrationwfw_45TPPpwbLbJieIAZzUXsCJKO0FTGF3txmJmXRFkdYMeta } from "/cre-app/client/pages/event-detail/lib/manualRegistration.ts?macro=true";
import { default as EventDetailProgramg1omYzwfx47VeSJEfaAj0YWmNQWvfHIBQsEh2wxluSgMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailProgram.vue?macro=true";
import { default as useSpeakerDetailQPX1f_bx1gwJ2FYuaut_45IE9GdAeELxwlZwR0zN8Ekz0Meta } from "/cre-app/client/pages/speaker-detail/lib/useSpeakerDetail.ts?macro=true";
import { default as SpeakerDetailBioh_5wDjtMJ_45B1zsiOjRbuDd1BENkfZKotlGXvC15OxsgMeta } from "/cre-app/client/pages/speaker-detail/ui/SpeakerDetailBio.vue?macro=true";
import { default as AdvertisingBodyca9hVfByAIvDhMPiktaXl5HFlb8d_h7_TYTle_45yaMYYMeta } from "/cre-app/client/pages/advertising_main/ui/AdvertisingBody.vue?macro=true";
import { default as AdvertisingMain0dlFmQOYpuXcO3FncI_45nCJp6QPG9oo7ADwnEcwl_45ZnoMeta } from "/cre-app/client/pages/advertising_main/ui/AdvertisingMain.vue?macro=true";
import { default as AddToCalendarButtonZf6EjA3oZa8M24wumBNGuPTC1FA782_zmRetjTP4vrQMeta } from "/cre-app/client/pages/event-detail/ui/AddToCalendarButton.vue?macro=true";
import { default as EventDetailContactsrMN3Qc0ViWJ0u6TzFdR2omYxB3U54p3NOOy_pj_mZckMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailContacts.vue?macro=true";
import { default as EventDetailPartners5ySoDV1OQPLW9SgXA8CNtFuy2XsxJ1ItiG6HlafJl_gMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailPartners.vue?macro=true";
import { default as SpeakerDetailHero5oXfGdAi9cyEDhliiQaJt0gxmrsyUIXyTc2tzuRZsCYMeta } from "/cre-app/client/pages/speaker-detail/ui/SpeakerDetailHero.vue?macro=true";
import { default as SpeakerDetailPageQ4QO6vICQNvcjKiIoasRRhSqgBJ_45IAjlhHxOe_tcyXwMeta } from "/cre-app/client/pages/speaker-detail/ui/SpeakerDetailPage.vue?macro=true";
import { default as EventDetailBroadcastsvMmvlwapj8_xvNFFUGLMz52_dzPC2zv9Aw_45pGXfq9AMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailBroadcast.vue?macro=true";
import { default as EventDetailMaterials9bqmfgu7o3Ho8v9766SRRpTNTVgndkRTkKdslX1xB2MMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailMaterials.vue?macro=true";
import { default as JournalAdvertisingContacts8dumSx92o5ZOJ2SbfuaJZnuWfA_45JZjdtgkYrjgGXCqIMeta } from "/cre-app/client/pages/journal/ui/JournalAdvertisingContacts.vue?macro=true";
import { default as JournalAdvertisingEditionshckSkNrpSRObbogV1gf6kqXlS_458zQ354HBoQ_SkR9QMMeta } from "/cre-app/client/pages/journal/ui/JournalAdvertisingEditions.vue?macro=true";
import { default as SpeakerDetailEvents88t3Iz1Qd_TDdbU6E7yqwXqM3lCunzozJ3GAqM0nm4EMeta } from "/cre-app/client/pages/speaker-detail/ui/SpeakerDetailEvents.vue?macro=true";
import { default as SpeakerDetailHeaderDpjSMjPBWHbuB6uICWJ6sGIXph1yedil1T5iYcJ387kMeta } from "/cre-app/client/pages/speaker-detail/ui/SpeakerDetailHeader.vue?macro=true";
import { default as useTimepadRegistrationJ0Z0rC75hfqT_0aKbHhtXMzbPCuLBaa7kwTyjORf2tQMeta } from "/cre-app/client/pages/event-detail/lib/useTimepadRegistration.ts?macro=true";
import { default as EventDetailProgramItemHOD9Psmpk4Blf92dophLz5qYNHc_45gY4IGO8MFcZ_DfgMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailProgramItem.vue?macro=true";
import { default as gallery_45detail_46consts9gmPBcxdODT7LnnPYJ_45wmhjv5WZpqD75n0CZ_45BaZv4Meta } from "/cre-app/client/pages/gallery-detail/lib/gallery-detail.const.ts?macro=true";
import { default as EventsBreadcrumbBandlA9oyR3DtjYcQAnhpHbSIKXnE0M3ZEJFx_nv2PYPupUMeta } from "/cre-app/client/pages/gallery-detail/ui/EventsBreadcrumbBand.vue?macro=true";
import { default as EventDetailTimepadModalSuPweWlE_S2Hc2ipNBn11KOu_wdCUZsTdFG_45eMRV61sMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailTimepadModal.vue?macro=true";
import { default as useEventGalleryDetailt4v4ks8xhMAykr0_CYlyLkTCy2uYbong81qil_0FiNAMeta } from "/cre-app/client/pages/gallery-detail/lib/useEventGalleryDetail.ts?macro=true";
import { default as EventDetailParticipation_3TmS2Jt4eFtrJmYp0WL6pOy8KKrE_m1bSYrs2T47voMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailParticipation.vue?macro=true";
import { default as EventsRelatedGalleriesQO12gsKtTiWgUt3XePa9n_45gtNiO9uLWWI_2YXD_d84UMeta } from "/cre-app/client/pages/gallery-detail/ui/EventsRelatedGalleries.vue?macro=true";
import { default as useSpeakerDetailEventspR7pCwc7V9u_mU50wTteus5ROYZhIpjKsd_453KRslym8Meta } from "/cre-app/client/pages/speaker-detail/lib/useSpeakerDetailEvents.ts?macro=true";
import { default as EventsGalleryDetailHeroLWJ3rgurmUd_45XU1KG6Pxwbka2Kvigq8UB4N8MBRr350Meta } from "/cre-app/client/pages/gallery-detail/ui/EventsGalleryDetailHero.vue?macro=true";
import { default as EventsGalleryDetailLayoutzG1xSGAYIZ4CDxb1_KCU3ynjGuC6olAJZ0wRMafJTHEMeta } from "/cre-app/client/pages/gallery-detail/ui/EventsGalleryDetailLayout.vue?macro=true";
import { default as EventDetailRegistrationModaltCmpfhbqwf3NnSIe6w1fwbpyKT48CgEd_45iE4ce_459YoIMeta } from "/cre-app/client/pages/event-detail/ui/EventDetailRegistrationModal.vue?macro=true";
import { default as EventsGalleryHeaderxcbnWqlwhS9TP6I3_45wV0nIWr7xV_45cc7eaW96NdfwP1gMeta } from "/cre-app/client/pages/events/ui/media-galleries/EventsGalleryHeader.vue?macro=true";
import { default as EventsMediaGalleriestastoA8eJkceqx0XlEuzHfb4RgW58nzPQem3_qAYp6YMeta } from "/cre-app/client/pages/events/ui/media-galleries/EventsMediaGalleries.vue?macro=true";
import { default as EventsPhotoGalleryDetailPagedbo6DZ55Lxu0JSPeZ2ms3ghbFvHz1Z5curqzluMaUWsMeta } from "/cre-app/client/pages/gallery-detail/ui/EventsPhotoGalleryDetailPage.vue?macro=true";
import { default as EventsVideoGalleryDetailPagea_cEcVfCpR_45AwIukvFi2P49Oc0gA_45dNa_YXXgj5mReQMeta } from "/cre-app/client/pages/gallery-detail/ui/EventsVideoGalleryDetailPage.vue?macro=true";
export default [
  {
    name: "tag",
    path: "/tag",
    component: () => import("/cre-app/client/pages/tag/index.ts")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/cre-app/client/pages/news/index.ts")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/cre-app/client/pages/events/index.ts")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/cre-app/client/pages/search/index.ts")
  },
  {
    name: "tag-ai",
    path: "/tag-ai",
    component: () => import("/cre-app/client/pages/tag-ai/index.ts")
  },
  {
    name: "tag-ui",
    path: "/tag/ui",
    component: () => import("/cre-app/client/pages/tag/ui/index.ts")
  },
  {
    name: "article",
    path: "/article",
    component: () => import("/cre-app/client/pages/article/index.ts")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/cre-app/client/pages/journal/index.ts")
  },
  {
    name: "news-ui",
    path: "/news/ui",
    component: () => import("/cre-app/client/pages/news/ui/index.ts")
  },
  {
    name: "news-ui-News",
    path: "/news/ui/News",
    component: () => import("/cre-app/client/pages/news/ui/News.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/cre-app/client/pages/contacts/index.ts")
  },
  {
    name: "events-lib-seo",
    path: "/events/lib/seo",
    component: () => import("/cre-app/client/pages/events/lib/seo.ts")
  },
  {
    name: "news-lib-const",
    path: "/news/lib/const",
    component: () => import("/cre-app/client/pages/news/lib/const.ts")
  },
  {
    name: "article-lib-seo",
    path: "/article/lib/seo",
    component: () => import("/cre-app/client/pages/article/lib/seo.ts")
  },
  {
    name: "events-ui",
    path: "/events/ui",
    component: () => import("/cre-app/client/pages/events/ui/index.ts")
  },
  {
    name: "home-page",
    path: "/home-page",
    component: () => import("/cre-app/client/pages/home-page/index.ts")
  },
  {
    name: "journal-lib-seo",
    path: "/journal/lib/seo",
    component: () => import("/cre-app/client/pages/journal/lib/seo.ts")
  },
  {
    name: "search-ui",
    path: "/search/ui",
    component: () => import("/cre-app/client/pages/search/ui/index.ts")
  },
  {
    name: "tag-ai-ui",
    path: "/tag-ai/ui",
    component: () => import("/cre-app/client/pages/tag-ai/ui/index.ts")
  },
  {
    name: "tag-ui-TagPage",
    path: "/tag/ui/TagPage",
    component: () => import("/cre-app/client/pages/tag/ui/TagPage.vue")
  },
  {
    name: "article-ui",
    path: "/article/ui",
    component: () => import("/cre-app/client/pages/article/ui/index.ts")
  },
  {
    name: "events-lib-const",
    path: "/events/lib/const",
    component: () => import("/cre-app/client/pages/events/lib/const.ts")
  },
  {
    name: "journal-ui",
    path: "/journal/ui",
    component: () => import("/cre-app/client/pages/journal/ui/index.ts")
  },
  {
    name: "tag-ai-lib-const",
    path: "/tag-ai/lib/const",
    component: () => import("/cre-app/client/pages/tag-ai/lib/const.ts")
  },
  {
    name: "advertising",
    path: "/advertising",
    component: () => import("/cre-app/client/pages/advertising/index.ts")
  },
  {
    name: "broker-pass",
    path: "/broker-pass",
    component: () => import("/cre-app/client/pages/broker-pass/index.ts")
  },
  {
    name: "contacts-ui",
    path: "/contacts/ui",
    component: () => import("/cre-app/client/pages/contacts/ui/index.ts")
  },
  {
    name: "home-page-lib-seo",
    path: "/home-page/lib/seo",
    component: () => import("/cre-app/client/pages/home-page/lib/seo.ts")
  },
  {
    name: "search-ui-Search",
    path: "/search/ui/Search",
    component: () => import("/cre-app/client/pages/search/ui/Search.vue")
  },
  {
    name: "event-detail",
    path: "/event-detail",
    component: () => import("/cre-app/client/pages/event-detail/index.ts")
  },
  {
    name: "home-page-ui",
    path: "/home-page/ui",
    component: () => import("/cre-app/client/pages/home-page/ui/index.ts")
  },
  {
    name: "home-page-lib-const",
    path: "/home-page/lib/const",
    component: () => import("/cre-app/client/pages/home-page/lib/const.ts")
  },
  {
    name: "advertising-ui",
    path: "/advertising/ui",
    component: () => import("/cre-app/client/pages/advertising/ui/index.ts")
  },
  {
    name: "broker-pass-ui",
    path: "/broker-pass/ui",
    component: () => import("/cre-app/client/pages/broker-pass/ui/index.ts")
  },
  {
    name: "event-detail-lib-seo",
    path: "/event-detail/lib/seo",
    component: () => import("/cre-app/client/pages/event-detail/lib/seo.ts")
  },
  {
    name: "gallery-detail",
    path: "/gallery-detail",
    component: () => import("/cre-app/client/pages/gallery-detail/index.ts")
  },
  {
    name: "speaker-detail",
    path: "/speaker-detail",
    component: () => import("/cre-app/client/pages/speaker-detail/index.ts")
  },
  {
    name: "tag-ai-ui-TagAiPage",
    path: "/tag-ai/ui/TagAiPage",
    component: () => import("/cre-app/client/pages/tag-ai/ui/TagAiPage.vue")
  },
  {
    name: "event-detail-ui",
    path: "/event-detail/ui",
    component: () => import("/cre-app/client/pages/event-detail/ui/index.ts")
  },
  {
    name: "events-ui-EventsPage",
    path: "/events/ui/EventsPage",
    component: () => import("/cre-app/client/pages/events/ui/EventsPage.vue")
  },
  {
    name: "advertising_main",
    path: "/advertising_main",
    component: () => import("/cre-app/client/pages/advertising_main/index.ts")
  },
  {
    name: "gallery-detail-lib-seo",
    path: "/gallery-detail/lib/seo",
    component: () => import("/cre-app/client/pages/gallery-detail/lib/seo.ts")
  },
  {
    name: "home-page-ui-HomePage",
    path: "/home-page/ui/HomePage",
    component: () => import("/cre-app/client/pages/home-page/ui/HomePage.vue")
  },
  {
    name: "speaker-detail-lib-seo",
    path: "/speaker-detail/lib/seo",
    component: () => import("/cre-app/client/pages/speaker-detail/lib/seo.ts")
  },
  {
    name: "article-ui-ArticlePage",
    path: "/article/ui/ArticlePage",
    meta: ArticlePageBy1BYpm3XkBrkuQF7vheRSpgS_45IFD94nSnIQxUpHyDMMeta || {},
    component: () => import("/cre-app/client/pages/article/ui/ArticlePage.vue")
  },
  {
    name: "events-ui-EventsTabBar",
    path: "/events/ui/EventsTabBar",
    component: () => import("/cre-app/client/pages/events/ui/EventsTabBar.vue")
  },
  {
    name: "events-ui-EventsTopBar",
    path: "/events/ui/EventsTopBar",
    component: () => import("/cre-app/client/pages/events/ui/EventsTopBar.vue")
  },
  {
    name: "gallery-detail-ui",
    path: "/gallery-detail/ui",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/index.ts")
  },
  {
    name: "journal-lib-coverAccent",
    path: "/journal/lib/coverAccent",
    component: () => import("/cre-app/client/pages/journal/lib/coverAccent.ts")
  },
  {
    name: "journal-ui-JournalHero",
    path: "/journal/ui/JournalHero",
    component: () => import("/cre-app/client/pages/journal/ui/JournalHero.vue")
  },
  {
    name: "journal-ui-JournalPage",
    path: "/journal/ui/JournalPage",
    component: () => import("/cre-app/client/pages/journal/ui/JournalPage.vue")
  },
  {
    name: "journal-ui-JournalTabs",
    path: "/journal/ui/JournalTabs",
    component: () => import("/cre-app/client/pages/journal/ui/JournalTabs.vue")
  },
  {
    name: "speaker-detail-ui",
    path: "/speaker-detail/ui",
    component: () => import("/cre-app/client/pages/speaker-detail/ui/index.ts")
  },
  {
    name: "events-ui-EventsSubTabs",
    path: "/events/ui/EventsSubTabs",
    component: () => import("/cre-app/client/pages/events/ui/EventsSubTabs.vue")
  },
  {
    name: "journal-lib-getIssueMeta",
    path: "/journal/lib/getIssueMeta",
    component: () => import("/cre-app/client/pages/journal/lib/getIssueMeta.ts")
  },
  {
    name: "journal-ui-JournalChips",
    path: "/journal/ui/JournalChips",
    component: () => import("/cre-app/client/pages/journal/ui/JournalChips.vue")
  },
  {
    name: "journal-ui-JournalCover",
    path: "/journal/ui/JournalCover",
    component: () => import("/cre-app/client/pages/journal/ui/JournalCover.vue")
  },
  {
    name: "advertising_main-ui",
    path: "/advertising_main/ui",
    component: () => import("/cre-app/client/pages/advertising_main/ui/index.ts")
  },
  {
    name: "contacts-ui-ContactsBody",
    path: "/contacts/ui/ContactsBody",
    component: () => import("/cre-app/client/pages/contacts/ui/ContactsBody.vue")
  },
  {
    name: "contacts-ui-ContactsPage",
    path: "/contacts/ui/ContactsPage",
    component: () => import("/cre-app/client/pages/contacts/ui/ContactsPage.vue")
  },
  {
    name: "journal-lib-journal.const",
    path: "/journal/lib/journal.const",
    component: () => import("/cre-app/client/pages/journal/lib/journal.const.ts")
  },
  {
    name: "broker-pass-ui-BrokerPage",
    path: "/broker-pass/ui/BrokerPage",
    component: () => import("/cre-app/client/pages/broker-pass/ui/BrokerPage.vue")
  },
  {
    name: "journal-lib-useJournalData",
    path: "/journal/lib/useJournalData",
    component: () => import("/cre-app/client/pages/journal/lib/useJournalData.ts")
  },
  {
    name: "journal-lib-useJournalPage",
    path: "/journal/lib/useJournalPage",
    component: () => import("/cre-app/client/pages/journal/lib/useJournalPage.ts")
  },
  {
    name: "journal-ui-JournalArchive",
    path: "/journal/ui/JournalArchive",
    component: () => import("/cre-app/client/pages/journal/ui/JournalArchive.vue")
  },
  {
    name: "advertising-ui-Advertising",
    path: "/advertising/ui/Advertising",
    component: () => import("/cre-app/client/pages/advertising/ui/Advertising.vue")
  },
  {
    name: "event-detail-lib-formatTime",
    path: "/event-detail/lib/formatTime",
    component: () => import("/cre-app/client/pages/event-detail/lib/formatTime.ts")
  },
  {
    name: "events-lib-useEventsFilters",
    path: "/events/lib/useEventsFilters",
    component: () => import("/cre-app/client/pages/events/lib/useEventsFilters.ts")
  },
  {
    name: "events-ui-EventsRouterView",
    path: "/events/ui/EventsRouterView",
    component: () => import("/cre-app/client/pages/events/ui/EventsRouterView.vue")
  },
  {
    name: "journal-lib-useJournalOrder",
    path: "/journal/lib/useJournalOrder",
    component: () => import("/cre-app/client/pages/journal/lib/useJournalOrder.ts")
  },
  {
    name: "journal-ui-JournalYearPage",
    path: "/journal/ui/JournalYearPage",
    component: () => import("/cre-app/client/pages/journal/ui/JournalYearPage.vue")
  },
  {
    name: "journal-lib-loadSmartCaptcha",
    path: "/journal/lib/loadSmartCaptcha",
    component: () => import("/cre-app/client/pages/journal/lib/loadSmartCaptcha.ts")
  },
  {
    name: "journal-ui-JournalCardsGrid",
    path: "/journal/ui/JournalCardsGrid",
    component: () => import("/cre-app/client/pages/journal/ui/JournalCardsGrid.vue")
  },
  {
    name: "journal-ui-JournalIssueCard",
    path: "/journal/ui/JournalIssueCard",
    component: () => import("/cre-app/client/pages/journal/ui/JournalIssueCard.vue")
  },
  {
    name: "journal-ui-JournalIssuePage",
    path: "/journal/ui/JournalIssuePage",
    component: () => import("/cre-app/client/pages/journal/ui/JournalIssuePage.vue")
  },
  {
    name: "journal-ui-JournalOrderForm",
    path: "/journal/ui/JournalOrderForm",
    component: () => import("/cre-app/client/pages/journal/ui/JournalOrderForm.vue")
  },
  {
    name: "tag-ai-ui-TagAiMaterialCard",
    path: "/tag-ai/ui/TagAiMaterialCard",
    component: () => import("/cre-app/client/pages/tag-ai/ui/TagAiMaterialCard.vue")
  },
  {
    name: "journal-ui-JournalOrderField",
    path: "/journal/ui/JournalOrderField",
    component: () => import("/cre-app/client/pages/journal/ui/JournalOrderField.vue")
  },
  {
    name: "journal-ui-JournalOrderModal",
    path: "/journal/ui/JournalOrderModal",
    component: () => import("/cre-app/client/pages/journal/ui/JournalOrderModal.vue")
  },
  {
    name: "journal-ui-JournalRouterView",
    path: "/journal/ui/JournalRouterView",
    component: () => import("/cre-app/client/pages/journal/ui/JournalRouterView.vue")
  },
  {
    name: "events-ui-afisha-EventsAfisha",
    path: "/events/ui/afisha/EventsAfisha",
    component: () => import("/cre-app/client/pages/events/ui/afisha/EventsAfisha.vue")
  },
  {
    name: "events-ui-afisha-EventsBanner",
    path: "/events/ui/afisha/EventsBanner",
    component: () => import("/cre-app/client/pages/events/ui/afisha/EventsBanner.vue")
  },
  {
    name: "journal-lib-journalOrder.const",
    path: "/journal/lib/journalOrder.const",
    component: () => import("/cre-app/client/pages/journal/lib/journalOrder.const.ts")
  },
  {
    name: "journal-ui-JournalIssuesPaged",
    path: "/journal/ui/JournalIssuesPaged",
    component: () => import("/cre-app/client/pages/journal/ui/JournalIssuesPaged.vue")
  },
  {
    name: "journal-ui-JournalRecommended",
    path: "/journal/ui/JournalRecommended",
    component: () => import("/cre-app/client/pages/journal/ui/JournalRecommended.vue")
  },
  {
    name: "event-detail-lib-useEventDetail",
    path: "/event-detail/lib/useEventDetail",
    component: () => import("/cre-app/client/pages/event-detail/lib/useEventDetail.ts")
  },
  {
    name: "journal-lib-useJournalOrderForm",
    path: "/journal/lib/useJournalOrderForm",
    component: () => import("/cre-app/client/pages/journal/lib/useJournalOrderForm.ts")
  },
  {
    name: "journal-ui-JournalIssueButtons",
    path: "/journal/ui/JournalIssueButtons",
    component: () => import("/cre-app/client/pages/journal/ui/JournalIssueButtons.vue")
  },
  {
    name: "journal-ui-JournalOrderCaptcha",
    path: "/journal/ui/JournalOrderCaptcha",
    component: () => import("/cre-app/client/pages/journal/ui/JournalOrderCaptcha.vue")
  },
  {
    name: "journal-ui-JournalOrderSuccess",
    path: "/journal/ui/JournalOrderSuccess",
    component: () => import("/cre-app/client/pages/journal/ui/JournalOrderSuccess.vue")
  },
  {
    name: "journal-ui-JournalOrderSummary",
    path: "/journal/ui/JournalOrderSummary",
    component: () => import("/cre-app/client/pages/journal/ui/JournalOrderSummary.vue")
  },
  {
    name: "journal-ui-JournalSectionRoute",
    path: "/journal/ui/JournalSectionRoute",
    component: () => import("/cre-app/client/pages/journal/ui/JournalSectionRoute.vue")
  },
  {
    name: "article-ui-ArticleNewObjectPage",
    path: "/article/ui/ArticleNewObjectPage",
    component: () => import("/cre-app/client/pages/article/ui/ArticleNewObjectPage.vue")
  },
  {
    name: "event-detail-lib-formatHallCount",
    path: "/event-detail/lib/formatHallCount",
    component: () => import("/cre-app/client/pages/event-detail/lib/formatHallCount.ts")
  },
  {
    name: "event-detail-ui-EventDetailHero",
    path: "/event-detail/ui/EventDetailHero",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailHero.vue")
  },
  {
    name: "event-detail-ui-EventDetailInfo",
    path: "/event-detail/ui/EventDetailInfo",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailInfo.vue")
  },
  {
    name: "event-detail-ui-EventDetailPage",
    path: "/event-detail/ui/EventDetailPage",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailPage.vue")
  },
  {
    name: "journal-ui-JournalEditionFilter",
    path: "/journal/ui/JournalEditionFilter",
    component: () => import("/cre-app/client/pages/journal/ui/JournalEditionFilter.vue")
  },
  {
    name: "event-detail-ui-MaterialCardText",
    path: "/event-detail/ui/MaterialCardText",
    component: () => import("/cre-app/client/pages/event-detail/ui/MaterialCardText.vue")
  },
  {
    name: "event-detail-ui-EventDetailFooter",
    path: "/event-detail/ui/EventDetailFooter",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailFooter.vue")
  },
  {
    name: "event-detail-ui-EventDetailHeader",
    path: "/event-detail/ui/EventDetailHeader",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailHeader.vue")
  },
  {
    name: "event-detail-ui-MaterialCardImage",
    path: "/event-detail/ui/MaterialCardImage",
    component: () => import("/cre-app/client/pages/event-detail/ui/MaterialCardImage.vue")
  },
  {
    name: "events-ui-schedule-EventsSchedule",
    path: "/events/ui/schedule/EventsSchedule",
    component: () => import("/cre-app/client/pages/events/ui/schedule/EventsSchedule.vue")
  },
  {
    name: "gallery-detail-lib-useGalleryModal",
    path: "/gallery-detail/lib/useGalleryModal",
    component: () => import("/cre-app/client/pages/gallery-detail/lib/useGalleryModal.ts")
  },
  {
    name: "event-detail-lib-manualRegistration",
    path: "/event-detail/lib/manualRegistration",
    component: () => import("/cre-app/client/pages/event-detail/lib/manualRegistration.ts")
  },
  {
    name: "event-detail-ui-EventDetailProgram",
    path: "/event-detail/ui/EventDetailProgram",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailProgram.vue")
  },
  {
    name: "speaker-detail-lib-useSpeakerDetail",
    path: "/speaker-detail/lib/useSpeakerDetail",
    component: () => import("/cre-app/client/pages/speaker-detail/lib/useSpeakerDetail.ts")
  },
  {
    name: "speaker-detail-ui-SpeakerDetailBio",
    path: "/speaker-detail/ui/SpeakerDetailBio",
    component: () => import("/cre-app/client/pages/speaker-detail/ui/SpeakerDetailBio.vue")
  },
  {
    name: "advertising_main-ui-AdvertisingBody",
    path: "/advertising_main/ui/AdvertisingBody",
    component: () => import("/cre-app/client/pages/advertising_main/ui/AdvertisingBody.vue")
  },
  {
    name: "advertising_main-ui-AdvertisingMain",
    path: "/advertising_main/ui/AdvertisingMain",
    component: () => import("/cre-app/client/pages/advertising_main/ui/AdvertisingMain.vue")
  },
  {
    name: "event-detail-ui-AddToCalendarButton",
    path: "/event-detail/ui/AddToCalendarButton",
    component: () => import("/cre-app/client/pages/event-detail/ui/AddToCalendarButton.vue")
  },
  {
    name: "event-detail-ui-EventDetailContacts",
    path: "/event-detail/ui/EventDetailContacts",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailContacts.vue")
  },
  {
    name: "event-detail-ui-EventDetailPartners",
    path: "/event-detail/ui/EventDetailPartners",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailPartners.vue")
  },
  {
    name: "speaker-detail-ui-SpeakerDetailHero",
    path: "/speaker-detail/ui/SpeakerDetailHero",
    component: () => import("/cre-app/client/pages/speaker-detail/ui/SpeakerDetailHero.vue")
  },
  {
    name: "speaker-detail-ui-SpeakerDetailPage",
    path: "/speaker-detail/ui/SpeakerDetailPage",
    component: () => import("/cre-app/client/pages/speaker-detail/ui/SpeakerDetailPage.vue")
  },
  {
    name: "event-detail-ui-EventDetailBroadcast",
    path: "/event-detail/ui/EventDetailBroadcast",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailBroadcast.vue")
  },
  {
    name: "event-detail-ui-EventDetailMaterials",
    path: "/event-detail/ui/EventDetailMaterials",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailMaterials.vue")
  },
  {
    name: "journal-ui-JournalAdvertisingContacts",
    path: "/journal/ui/JournalAdvertisingContacts",
    component: () => import("/cre-app/client/pages/journal/ui/JournalAdvertisingContacts.vue")
  },
  {
    name: "journal-ui-JournalAdvertisingEditions",
    path: "/journal/ui/JournalAdvertisingEditions",
    component: () => import("/cre-app/client/pages/journal/ui/JournalAdvertisingEditions.vue")
  },
  {
    name: "speaker-detail-ui-SpeakerDetailEvents",
    path: "/speaker-detail/ui/SpeakerDetailEvents",
    component: () => import("/cre-app/client/pages/speaker-detail/ui/SpeakerDetailEvents.vue")
  },
  {
    name: "speaker-detail-ui-SpeakerDetailHeader",
    path: "/speaker-detail/ui/SpeakerDetailHeader",
    component: () => import("/cre-app/client/pages/speaker-detail/ui/SpeakerDetailHeader.vue")
  },
  {
    name: "event-detail-lib-useTimepadRegistration",
    path: "/event-detail/lib/useTimepadRegistration",
    component: () => import("/cre-app/client/pages/event-detail/lib/useTimepadRegistration.ts")
  },
  {
    name: "event-detail-ui-EventDetailProgramItem",
    path: "/event-detail/ui/EventDetailProgramItem",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailProgramItem.vue")
  },
  {
    name: "gallery-detail-lib-gallery-detail.const",
    path: "/gallery-detail/lib/gallery-detail.const",
    component: () => import("/cre-app/client/pages/gallery-detail/lib/gallery-detail.const.ts")
  },
  {
    name: "gallery-detail-ui-EventsBreadcrumbBand",
    path: "/gallery-detail/ui/EventsBreadcrumbBand",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/EventsBreadcrumbBand.vue")
  },
  {
    name: "event-detail-ui-EventDetailTimepadModal",
    path: "/event-detail/ui/EventDetailTimepadModal",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailTimepadModal.vue")
  },
  {
    name: "gallery-detail-lib-useEventGalleryDetail",
    path: "/gallery-detail/lib/useEventGalleryDetail",
    component: () => import("/cre-app/client/pages/gallery-detail/lib/useEventGalleryDetail.ts")
  },
  {
    name: "event-detail-ui-EventDetailParticipation",
    path: "/event-detail/ui/EventDetailParticipation",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailParticipation.vue")
  },
  {
    name: "gallery-detail-ui-EventsRelatedGalleries",
    path: "/gallery-detail/ui/EventsRelatedGalleries",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/EventsRelatedGalleries.vue")
  },
  {
    name: "speaker-detail-lib-useSpeakerDetailEvents",
    path: "/speaker-detail/lib/useSpeakerDetailEvents",
    component: () => import("/cre-app/client/pages/speaker-detail/lib/useSpeakerDetailEvents.ts")
  },
  {
    name: "gallery-detail-ui-EventsGalleryDetailHero",
    path: "/gallery-detail/ui/EventsGalleryDetailHero",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/EventsGalleryDetailHero.vue")
  },
  {
    name: "gallery-detail-ui-EventsGalleryDetailLayout",
    path: "/gallery-detail/ui/EventsGalleryDetailLayout",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/EventsGalleryDetailLayout.vue")
  },
  {
    name: "event-detail-ui-EventDetailRegistrationModal",
    path: "/event-detail/ui/EventDetailRegistrationModal",
    component: () => import("/cre-app/client/pages/event-detail/ui/EventDetailRegistrationModal.vue")
  },
  {
    name: "events-ui-media-galleries-EventsGalleryHeader",
    path: "/events/ui/media-galleries/EventsGalleryHeader",
    component: () => import("/cre-app/client/pages/events/ui/media-galleries/EventsGalleryHeader.vue")
  },
  {
    name: "events-ui-media-galleries-EventsMediaGalleries",
    path: "/events/ui/media-galleries/EventsMediaGalleries",
    component: () => import("/cre-app/client/pages/events/ui/media-galleries/EventsMediaGalleries.vue")
  },
  {
    name: "gallery-detail-ui-EventsPhotoGalleryDetailPage",
    path: "/gallery-detail/ui/EventsPhotoGalleryDetailPage",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/EventsPhotoGalleryDetailPage.vue")
  },
  {
    name: "gallery-detail-ui-EventsVideoGalleryDetailPage",
    path: "/gallery-detail/ui/EventsVideoGalleryDetailPage",
    component: () => import("/cre-app/client/pages/gallery-detail/ui/EventsVideoGalleryDetailPage.vue")
  }
]